
import { Link } from 'react-router-dom';

interface BlogPostCardProps {
  slug: string;
  image: string;
  category: string;
  categoryIcon: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
}

export default function BlogPostCard({
  slug,
  image,
  category,
  categoryIcon,
  title,
  excerpt,
  date,
  readTime,
}: BlogPostCardProps) {
  return (
    <Link
      to={`/blog/${slug}`}
      className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 cursor-pointer group"
    >
      <div className="relative h-52 sm:h-56 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-sky-600 text-white text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5">
            <i className={`${categoryIcon} text-sm`}></i>
            {category}
          </span>
        </div>
      </div>
      <div className="p-5 sm:p-6">
        <div className="flex items-center gap-3 text-xs text-gray-500 mb-3">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
        <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 group-hover:text-sky-600 transition-colors leading-snug">
          {title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-4">{excerpt}</p>
        <span className="inline-flex items-center gap-1.5 text-sky-600 text-sm font-semibold group-hover:gap-2.5 transition-all">
          Read Full Article
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}
